import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveAllOrganizationalUnitsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveAllOrganizationalUnitsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveAllOrganizationalUnitsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getAllOrganizationalUnits() {
      return getState().organizationalUnits;
    },
    getAllOrganizationalUnitsFilter() {
      return getState().filter;
    },
    getAllOrganizationalUnitsTotalPages() {
      return getState().totalPages;
    },
  };
}

export { createSelector };
